import apiClient from '@services/api/apiClient.jsx';

/**
 * 테마 앵글 매핑 API 서비스
 */
const themeAngleMappingApi = {
    /**
     * 테마별 앵글 매핑 목록 조회
     */
    getThemeAngleMappings: async (themeId, themePageId) => {
        try {
            const response = await apiClient.get(`/theme-angle-mappings`, {
                params: { themeId, themePageId }
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 앵글 매핑 목록 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 특정 테마 앵글 매핑 조회
     */
    getThemeAngleMapping: async (mappingId) => {
        try {
            const response = await apiClient.get(`/theme-angle-mappings/${mappingId}`);
            return response.data.data;
        } catch (error) {
            console.error('테마 앵글 매핑 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 추가 가능한 앵글 목록 조회
     * @param {string} themeId - 테마 ID
     * @param {object} filters - 필터 옵션 (isPhoto, isVideo, isGreeting)
     */
    getAvailableAngles: async (themeId, filters = {}) => {
        try {
            const params = { themeId };
            
            // 필터 파라미터 추가
            if (filters.isPhoto !== undefined) {
                params.isPhoto = filters.isPhoto;
            }
            if (filters.isVideo !== undefined) {
                params.isVideo = filters.isVideo;
            }
            if (filters.isGreeting !== undefined) {
                params.isGreeting = filters.isGreeting;
            }
            
            const response = await apiClient.get(`/theme-angle-mappings/available-angles`, {
                params
            });
            return response.data.data;
        } catch (error) {
            console.error('사용 가능한 앵글 목록 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 테마에 앵글 추가
     */
    addAngleToTheme: async (themeId, themePageId, cameraAngleId, customImages = {}) => {
        try {
            const formData = new FormData();
            formData.append('themeId', themeId);
            formData.append('themePageId', themePageId);
            formData.append('cameraAngleId', cameraAngleId);

            if (customImages.defaultImageResourceId) {
                formData.append('customDefaultImageResourceId', customImages.defaultImageResourceId);
            }
            if (customImages.hoverImageResourceId) {
                formData.append('customHoverImageResourceId', customImages.hoverImageResourceId);
            }
            if (customImages.displayOrder) {
                formData.append('displayOrder', customImages.displayOrder);
            }

            const response = await apiClient.post(`/theme-angle-mappings`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('테마에 앵글 추가 실패:', error);
            throw error;
        }
    },

    /**
     * 테마 앵글 매핑 수정
     */
    updateThemeAngleMapping: async (mappingId, updateData) => {
        try {
            const formData = new FormData();

            if (updateData.customDefaultImageResourceId !== undefined) {
                formData.append('customDefaultImageResourceId', updateData.customDefaultImageResourceId || '');
            }
            if (updateData.customHoverImageResourceId !== undefined) {
                formData.append('customHoverImageResourceId', updateData.customHoverImageResourceId || '');
            }
            if (updateData.displayOrder !== undefined) {
                formData.append('displayOrder', updateData.displayOrder);
            }
            if (updateData.isActive !== undefined) {
                formData.append('isActive', updateData.isActive);
            }

            const response = await apiClient.put(`/theme-angle-mappings/${mappingId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 앵글 매핑 수정 실패:', error);
            throw error;
        }
    },

    /**
     * 테마에서 앵글 제거
     */
    removeAngleFromTheme: async (mappingId) => {
        try {
            const response = await apiClient.delete(`/theme-angle-mappings/${mappingId}`);
            return response.data.success;
        } catch (error) {
            console.error('테마에서 앵글 제거 실패:', error);
            throw error;
        }
    },

    /**
     * 앵글 순서 변경
     */
    reorderAngles: async (themeId, mappingOrders) => {
        try {
            const requestData = {
                themeId,
                mappingOrders
            };

            const response = await apiClient.put(`/theme-angle-mappings/reorder`, requestData);
            return response.data.success;
        } catch (error) {
            console.error('앵글 순서 변경 실패:', error);
            throw error;
        }
    },

    /**
     * 테마별 앵글 매핑 수 조회
     */
    getThemeAngleMappingCount: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-angle-mappings/count`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 앵글 매핑 수 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 앵글 중복 체크
     */
    checkAngleDuplicate: async (themeId, cameraAngleId) => {
        try {
            const response = await apiClient.get(`/theme-angle-mappings/check-duplicate`, {
                params: { themeId, cameraAngleId }
            });
            return response.data.data; // true: 사용 가능, false: 중복
        } catch (error) {
            console.error('앵글 중복 체크 실패:', error);
            throw error;
        }
    }
};

export default themeAngleMappingApi;
